import React from 'react';

import './customFieldsetStyles.css';

type Props = {
  disabled?: boolean;
};

/**
 * Компонент дает возможность дизейблить
 * все инпуты, размещенные внутри.
 *
 * Также компонентом задаются стандартные зазоры
 * между инпутами.
 */

export const CustomFieldsetComponent: React.FC<Props> = (props) => {
  const { disabled, children } = props;

  return (
    <fieldset className="custom-fieldset__wrapper" disabled={disabled}>
      <div className="custom-fieldset__slot">{children}</div>
    </fieldset>
  );
};
